'use client';

import Link from 'next/link';
import { BlogCategoryDocument } from '../../../prismicio-types';

interface Props {
  selectedCategory?: string;
  categories?: BlogCategoryDocument[];
}

export const HorizontalCategoriesSearch = ({
  selectedCategory,
  categories = [],
}: Props) => {
  const generateLinkClass = () =>
    `py-1 px-3 w-full rounded-full text-xs whitespace-nowrap`;

  return (
    <section className="flex flex-row gap-6 shrink-0 items-center text-sm w-full max-w-screen-2xl mx-auto">
      <div className="flex flex-row gap-3 items-center"></div>
      <div className="flex flex-row gap-x-2 shrink-0 overflow-x-auto no-scrollbar items-center min-w-0 flex-1">
        {/* Category List */}
        <Link
          href="/blog"
          className={generateLinkClass()}
          style={{
            borderColor: selectedCategory ? '#026846' : '#05F273',
            color: selectedCategory ? '#026846' : '#05F273',
            fontWeight: selectedCategory ? 'normal' : 'bold',
            borderWidth: '1px', // Explicitly set border width
            borderStyle: 'solid', // Explicitly set border style
          }}
        >
          All resources
        </Link>
        {categories.map((category, index) => {
          return (
            <Link
              key={`category_${index.toString()}`}
              href={`/blog?category=${category.uid}`}
              className={generateLinkClass()}
              style={{
                borderColor:
                  category.uid === selectedCategory ? '#05F273' : '#026846',
                color:
                  category.uid === selectedCategory ? '#05F273' : '#026846',
                fontWeight:
                  category.uid === selectedCategory ? 'bold' : 'normal',
                borderWidth: '1px', // Explicitly set border width
                borderStyle: 'solid', // Explicitly set border style
              }}
            >
              {category.data.name}
            </Link>
          );
        })}
      </div>
    </section>
  );
};
